export const formatTime = (time: any, includeTimezone = false, locale = 'he-IL'): string => {
  const hour12 = time.hour % 12 || 12;
  const period = time.hour < 12 ? 'AM' : 'PM';
  const timeString = `${hour12}:${time.minute.toString().padStart(2, '0')} ${period}`;

  return includeTimezone ? `${timeString} (Europe time)` : timeString;
};

export const formatDate = (date: Date, format: 'short' | 'long' = 'short', locale = 'he-IL'): string => {
  if (format === 'long') {
    return date.toLocaleDateString(locale, {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  }

  const day = date.getDate();
  const month = date.toLocaleString(locale, { month: 'short' });
  return `${day} ${month}`;
};

export const getDayName = (date: Date, locale = 'he-IL'): string => {
  return date.toLocaleString(locale, { weekday: 'short' });
};
